module.exports = __webpack_public_path__ + "static/media/featured.7004f81c.png";